import React from "react";

const Footer = () => {
  return (
    <footer style={{
      textAlign: "center",
      color: "black",
      backgroundColor: "linear-gradient(#FFFFFF 20%, #f5ad8bff 100%)",
      width: "100%",
      paddingBottom: "0.5rem",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      position: "relative",
      zIndex: 10
    }}>
      ©2026 Addnectar Solutions Inc. All rights reserved.
    </footer>
  );
};

export default Footer;
